/* Plakton South Africa. Quick view, wishlist, compare and cart edit.
   Builds on window.Plakton from theme.js. No dependencies. */
(function () {
  'use strict';

  var P = window.Plakton;
  if (!P) return;
  var F = window.plaktonFeatures || {};
  var routes = window.plaktonRoutes || {};
  var qs = P.qs, qsa = P.qsa;

  var root = String(F.rootUrl || '/').replace(/\/$/, '');
  function productUrl(handle) { return root + '/products/' + encodeURIComponent(handle); }
  function sectionUrl(url, section) { return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + section; }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------ money */
  function formatMoney(cents, format) {
    format = format || window.plaktonMoneyFormat || 'R {{amount}}';
    cents = parseInt(cents, 10) || 0;
    function withDelims(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(cents, 0, ' ', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ------------------------------------------------------------ toast */
  var toastEl = qs('[data-toast]');
  var toastTimer = null;
  function toast(text, linkLabel, href) {
    if (!toastEl) return;
    qs('[data-toast-text]', toastEl).textContent = text;
    var link = qs('[data-toast-link]', toastEl);
    if (linkLabel && href) { link.textContent = linkLabel; link.href = href; link.hidden = false; }
    else { link.hidden = true; }
    toastEl.hidden = false;
    window.requestAnimationFrame(function () { toastEl.classList.add('is-in'); });
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toastEl.classList.remove('is-in');
      window.setTimeout(function () { toastEl.hidden = true; }, 400);
    }, 3200);
  }

  /* ------------------------------------------------------ saved lists */
  // Each entry is { h: handle, t: title, i: image url } so the compare bar and
  // header can draw without a network request.
  function List(key, max) {
    function read() {
      try { var v = JSON.parse(P.store(key) || '[]'); return Array.isArray(v) ? v : []; }
      catch (e) { return []; }
    }
    function write(items) { P.store(key, JSON.stringify(items)); sync(); }
    return {
      max: max,
      read: read,
      has: function (h) { return read().some(function (x) { return x.h === h; }); },
      add: function (item) {
        var items = read().filter(function (x) { return x.h !== item.h; });
        if (max && items.length >= max) return false;
        items.push(item); write(items); return true;
      },
      remove: function (h) { write(read().filter(function (x) { return x.h !== h; })); },
      clear: function () { write([]); }
    };
  }

  var wishlist = List('plakton_wishlist_v1', 60);
  var compare = List('plakton_compare_v1', parseInt(F.compareMax, 10) || 4);

  function itemFrom(btn, handle) {
    var card = btn.closest('[data-card]');
    var src = card || btn;
    return {
      h: handle,
      t: src.getAttribute('data-title') || '',
      i: src.getAttribute('data-image') || ''
    };
  }

  function setToggle(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', String(active));
    var label = qs('[data-label-on]', btn);
    if (label) label.textContent = label.getAttribute(active ? 'data-label-on' : 'data-label-off');
  }

  function sync() {
    var w = wishlist.read().map(function (x) { return x.h; });
    var c = compare.read().map(function (x) { return x.h; });
    qsa('[data-wishlist-toggle]').forEach(function (b) { setToggle(b, w.indexOf(b.getAttribute('data-wishlist-toggle')) !== -1); });
    qsa('[data-compare-toggle]').forEach(function (b) { setToggle(b, c.indexOf(b.getAttribute('data-compare-toggle')) !== -1); });
    qsa('[data-wishlist-count]').forEach(function (el) { el.textContent = w.length; el.setAttribute('data-count', w.length); });
    renderCompareBar();
  }

  function pop(btn) {
    if (P.reduced) return;
    btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop');
  }

  /* -------------------------------------------------------- compare bar */
  var bar = qs('[data-compare-bar]');
  function renderCompareBar() {
    if (!bar) return;
    var items = compare.read();
    var slots = qs('[data-compare-slots]', bar);
    var html = '';
    for (var i = 0; i < compare.max; i++) {
      var it = items[i];
      html += '<div class="compare-bar__slot">' + (it
        ? (it.i ? '<img src="' + escapeHtml(it.i) + '" alt="' + escapeHtml(it.t) + '" width="48" height="48">' : '') +
          '<button type="button" data-compare-toggle="' + escapeHtml(it.h) + '" aria-label="Remove ' + escapeHtml(it.t) + ' from compare">' +
          '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
        : '') + '</div>';
    }
    slots.innerHTML = html;
    var count = qs('[data-compare-count]', bar);
    if (count) count.textContent = items.length ? '(' + items.length + ')' : '';
    var go = qs('[data-compare-go]', bar);
    if (go) go.removeAttribute('aria-disabled');
    if (items.length) {
      bar.hidden = false;
      window.requestAnimationFrame(function () { bar.classList.add('is-in'); });
    } else if (!bar.hidden) {
      bar.classList.remove('is-in');
      window.setTimeout(function () { if (!compare.read().length) bar.hidden = true; }, 450);
    }
  }

  /* --------------------------------------------------------- quick view */
  var qvEl = qs('[data-quick-view-modal]');
  var qv = qvEl ? P.Panel(qvEl) : null;
  var qvBody = qvEl ? qs('[data-quick-view-body]', qvEl) : null;
  var qvLoading = qvBody ? qvBody.innerHTML : '';
  var qvCache = {};
  var qvController = null;

  function openQuickView(url, trigger) {
    if (!qv || !url) { if (url) window.location.href = url; return; }
    if (qvController) qvController.abort();
    qvController = new AbortController();
    if (trigger) trigger.classList.add('loading');
    qvBody.innerHTML = qvLoading;
    P.closeSearch();
    qv.open();

    var cached = qvCache[url];
    var load = cached ? Promise.resolve(cached) : fetch(sectionUrl(url, 'quick-view'), { signal: qvController.signal })
      .then(function (r) { if (!r.ok) throw new Error('qv'); return r.text(); });

    load.then(function (html) {
      qvCache[url] = html;
      var fresh = parse(html).querySelector('[data-qv-root]');
      if (!fresh) throw new Error('qv');
      qvBody.innerHTML = '';
      qvBody.appendChild(fresh);
      var gallery = qs('[data-gallery]', fresh);
      if (gallery) P.Gallery(gallery);
      P.VariantPicker(fresh);
      sync();
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      window.location.href = url;
    }).finally(function () {
      if (trigger) trigger.classList.remove('loading');
    });
  }

  document.addEventListener('plakton:cart:added', function () {
    if (qv && qv.isOpen()) qv.close();
  });

  /* ------------------------------------------------------ click handling */
  document.addEventListener('click', function (e) {
    var wBtn = e.target.closest('[data-wishlist-toggle]');
    if (wBtn) {
      e.preventDefault(); e.stopPropagation();
      var wh = wBtn.getAttribute('data-wishlist-toggle');
      if (wishlist.has(wh)) {
        wishlist.remove(wh);
        toast('Removed from your wishlist');
      } else {
        wishlist.add(itemFrom(wBtn, wh));
        pop(wBtn);
        toast('Saved to your wishlist', F.wishlistUrl ? 'View wishlist' : '', F.wishlistUrl);
      }
      return;
    }

    var cBtn = e.target.closest('[data-compare-toggle]');
    if (cBtn) {
      e.preventDefault(); e.stopPropagation();
      var ch = cBtn.getAttribute('data-compare-toggle');
      if (compare.has(ch)) {
        compare.remove(ch);
      } else if (!compare.add(itemFrom(cBtn, ch))) {
        toast('You can compare up to ' + compare.max + ' styles', F.compareUrl ? 'Compare now' : '', F.compareUrl);
      } else {
        pop(cBtn);
      }
      return;
    }

    var clear = e.target.closest('[data-compare-clear]');
    if (clear) { e.preventDefault(); compare.clear(); renderComparePage(); return; }

    var go = e.target.closest('[data-compare-go]');
    if (go && (!compare.read().length || go.getAttribute('href') === '#')) {
      e.preventDefault();
      toast(compare.read().length ? 'The compare page has not been set up yet' : 'Add a style to compare first');
      return;
    }

    var qvBtn = e.target.closest('[data-quick-view]');
    if (qvBtn) {
      e.preventDefault(); e.stopPropagation();
      openQuickView(qvBtn.getAttribute('data-quick-view'), qvBtn);
    }
  });

  // Another tab changed a list.
  window.addEventListener('storage', function (e) {
    if (e.key && e.key.indexOf('plakton_') === 0) sync();
  });

  // Filtering, pagination and search swap cards in without a reload.
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (records) {
      if (pending) return;
      var relevant = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('[data-card], [data-wishlist-toggle], [data-compare-toggle]') || n.querySelector('[data-card], [data-wishlist-toggle], [data-compare-toggle]'));
        });
      });
      if (!relevant) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; sync(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------ wishlist page */
  var wlPage = qs('[data-wishlist-page]');
  function renderWishlistPage() {
    if (!wlPage) return;
    var grid = qs('[data-wl-grid]', wlPage);
    var empty = qs('[data-wl-empty]', wlPage);
    var loading = qs('[data-wl-loading]', wlPage);
    var items = wishlist.read();
    if (!items.length) { loading.hidden = true; grid.innerHTML = ''; empty.hidden = false; return; }

    Promise.all(items.map(function (it) {
      return fetch(sectionUrl(productUrl(it.h), 'wishlist-item'))
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          var el = html ? parse(html).querySelector('[data-wl-item]') : null;
          if (!el) wishlist.remove(it.h); // product deleted or unpublished
          return el;
        })
        .catch(function () { return null; });
    })).then(function (els) {
      loading.hidden = true;
      grid.innerHTML = '';
      els.forEach(function (el) { if (el) { grid.appendChild(el); bindWishlistItem(el); } });
      empty.hidden = grid.children.length > 0;
    });
  }

  function bindWishlistItem(el) {
    var variants = [];
    try { variants = JSON.parse(qs('[data-wl-variants]', el).textContent); } catch (e) {}
    var addBtn = qs('[data-wl-add]', el);
    var priceEl = qs('[data-wl-price]', el);
    var selects = qsa('[data-wl-option]', el);

    function current() {
      var opts = selects.map(function (s) { return s.value; });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var v = current();
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      addBtn.setAttribute('data-wl-add', v.id);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    if (selects.length) update();

    addBtn.addEventListener('click', function () {
      addBtn.classList.add('loading');
      var flight = P.flyToCart(qs('.wl-item__media img', el));
      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(addBtn.getAttribute('data-wl-add'), 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.body.description || 'Could not add that to your cart'); return; }
          return Promise.all([flight, P.refreshCartUI()]).then(function () {
            document.dispatchEvent(new CustomEvent('plakton:cart:added'));
            P.openCart();
          });
        })
        .finally(function () { addBtn.classList.remove('loading'); });
    });

    qs('[data-wl-remove]', el).addEventListener('click', function () {
      var h = el.getAttribute('data-handle');
      function done() {
        el.remove();
        wishlist.remove(h);
        qs('[data-wl-empty]', wlPage).hidden = qs('[data-wl-grid]', wlPage).children.length > 0;
      }
      if (P.reduced) { done(); return; }
      el.classList.add('is-leaving');
      window.setTimeout(done, 320);
    });
  }

  /* ------------------------------------------------------- compare page */
  var cmpPage = qs('[data-compare-page]');
  function renderComparePage() {
    if (!cmpPage) return;
    var wrap = qs('[data-cmp-table-wrap]', cmpPage);
    var empty = qs('[data-cmp-empty]', cmpPage);
    var loading = qs('[data-cmp-loading]', cmpPage);
    var clearBtn = qs('[data-compare-clear]');
    var items = compare.read();
    if (!items.length) {
      loading.hidden = true; wrap.hidden = true; wrap.innerHTML = ''; empty.hidden = false;
      if (clearBtn) clearBtn.hidden = true;
      return;
    }
    loading.hidden = false;

    Promise.all(items.map(function (it) {
      return fetch(sectionUrl(productUrl(it.h), 'compare-item'))
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          var el = html ? parse(html).querySelector('[data-cmp-item]') : null;
          if (!el) compare.remove(it.h);
          return el;
        })
        .catch(function () { return null; });
    })).then(function (els) {
      els = els.filter(Boolean);
      loading.hidden = true;
      if (!els.length) { wrap.hidden = true; empty.hidden = false; return; }

      var keys = qsa('[data-cell]', els[0]).map(function (c) { return c.getAttribute('data-cell'); });
      var rows = keys.map(function (key) {
        var cells = els.map(function (el) { return qs('[data-cell="' + key + '"]', el); });
        var label = cells[0] ? cells[0].getAttribute('data-label') : '';
        var filled = cells.some(function (c) { return c && (c.textContent.trim() || c.querySelector('img')); });
        if (!filled) return '';
        return '<tr><th scope="row">' + (label ? escapeHtml(label) : '<span class="visually-hidden">Product</span>') + '</th>' +
          cells.map(function (c) { return '<td>' + (c ? c.innerHTML : '') + '</td>'; }).join('') + '</tr>';
      }).join('');

      wrap.innerHTML = '<table class="compare-table" style="min-width:' + (130 + els.length * 210) + 'px"><tbody>' + rows + '</tbody></table>';
      if (els.length < 2) {
        wrap.insertAdjacentHTML('beforeend', '<p class="muted" style="margin-top:1.5rem;font-size:0.875rem">Add one more style to see them side by side.</p>');
      }
      wrap.hidden = false;
      empty.hidden = true;
      if (clearBtn) clearBtn.hidden = false;
    });
  }

  if (cmpPage) {
    cmpPage.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cmp-remove]');
      if (!rm) return;
      e.preventDefault();
      compare.remove(rm.getAttribute('data-cmp-remove'));
      renderComparePage();
    });
  }

  /* ---------------------------------------------------------- cart edit */
  // Shopify cannot swap a line's variant in place, so an edit adds the new
  // variant first and only removes the old line once that succeeds. If the new
  // size is out of stock, the original line is left untouched.
  var editPanel = qs('[data-cart-edit-panel]');
  var editState = null;

  function closeEdit() {
    if (!editPanel) return;
    editPanel.classList.remove('is-open');
    editPanel.setAttribute('aria-hidden', 'true');
    editState = null;
  }

  function openEdit(lineEl) {
    if (!editPanel || !lineEl) return;
    var body = qs('[data-cart-edit-body]', editPanel);
    var err = qs('[data-cart-edit-error]', editPanel);
    err.hidden = true;
    body.innerHTML = qvLoading || '';
    editPanel.classList.add('is-open');
    editPanel.setAttribute('aria-hidden', 'false');

    var props = {};
    try { props = JSON.parse(lineEl.getAttribute('data-line-props') || '{}'); } catch (e) {}
    editState = {
      key: lineEl.getAttribute('data-line-key'),
      variant: parseInt(lineEl.getAttribute('data-line-variant'), 10),
      qty: parseInt(lineEl.getAttribute('data-line-qty'), 10) || 1,
      props: props,
      product: null
    };
    var state = editState;

    fetch(productUrl(lineEl.getAttribute('data-line-handle')) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        if (state !== editState) return;
        state.product = product;
        var current = product.variants.find(function (v) { return v.id === state.variant; }) || product.variants[0];
        var img = (current.featured_image && current.featured_image.src) || product.featured_image || '';

        var html = '<div class="cart-edit__product">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" width="84" height="105" data-ce-img>' : '<span></span>') +
          '<div><p class="cart-line__title">' + escapeHtml(product.title) + '</p>' +
          '<p class="cart-line__meta" data-ce-price>' + formatMoney(current.price) + '</p></div></div>';

        product.options.forEach(function (opt, oi) {
          var name = typeof opt === 'string' ? opt : opt.name;
          var values = typeof opt === 'string'
            ? product.variants.map(function (v) { return v.options[oi]; }).filter(function (v, i, a) { return a.indexOf(v) === i; })
            : opt.values;
          html += '<div class="option"><div class="option__head"><span class="option__label">' + escapeHtml(name) +
            ': <span class="option__value" data-ce-selected="' + oi + '">' + escapeHtml(current.options[oi]) + '</span></span></div>' +
            '<div class="option__values">';
          values.forEach(function (val, vi) {
            var id = 'ce-' + oi + '-' + vi;
            html += '<span style="position:relative;display:inline-flex">' +
              '<input type="radio" id="' + id + '" name="ce-' + oi + '" value="' + escapeHtml(val) + '" data-ce-option="' + oi + '"' +
              (current.options[oi] === val ? ' checked' : '') + '>' +
              '<label class="option__btn" for="' + id + '">' + escapeHtml(val) + '</label></span>';
          });
          html += '</div></div>';
        });
        body.innerHTML = html;
        refreshEdit();
      })
      .catch(function () {
        body.innerHTML = '<p class="muted">This item cannot be edited right now.</p>';
      });
  }

  function selectedEditVariant() {
    if (!editState || !editState.product) return null;
    var opts = qsa('[data-ce-option]:checked', editPanel).map(function (i) { return i.value; });
    return editState.product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
  }

  function refreshEdit() {
    if (!editState || !editState.product) return;
    var product = editState.product;
    var opts = qsa('[data-ce-option]:checked', editPanel).map(function (i) { return i.value; });
    qsa('[data-ce-option]', editPanel).forEach(function (input) {
      var idx = parseInt(input.getAttribute('data-ce-option'), 10);
      input.disabled = !product.variants.some(function (v) {
        return v.available && v.options.every(function (o, i) { return i === idx ? o === input.value : o === opts[i]; });
      });
    });
    qsa('[data-ce-selected]', editPanel).forEach(function (el) {
      el.textContent = opts[parseInt(el.getAttribute('data-ce-selected'), 10)] || '';
    });
    var v = selectedEditVariant();
    var save = qs('[data-cart-edit-save]', editPanel);
    save.disabled = !v || !v.available;
    save.textContent = !v ? 'Unavailable' : (v.available ? 'Update item' : 'Sold out');
    if (v) {
      var price = qs('[data-ce-price]', editPanel);
      if (price) price.textContent = formatMoney(v.price);
      var img = qs('[data-ce-img]', editPanel);
      if (img && v.featured_image && v.featured_image.src) img.src = v.featured_image.src;
    }
  }

  function saveEdit() {
    var v = selectedEditVariant();
    if (!v || !editState) return;
    var state = editState;
    if (v.id === state.variant) { closeEdit(); return; }
    var save = qs('[data-cart-edit-save]', editPanel);
    var err = qs('[data-cart-edit-error]', editPanel);
    save.classList.add('loading');
    err.hidden = true;

    var item = { id: v.id, quantity: state.qty };
    if (Object.keys(state.props).length) item.properties = state.props;

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          err.textContent = res.body.description || res.body.message || 'That option could not be added.';
          err.hidden = false;
          return;
        }
        return fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: state.key, quantity: 0 })
        }).then(P.refreshCartUI).then(closeEdit);
      })
      .catch(function () {
        err.textContent = 'Something went wrong. Please try again.';
        err.hidden = false;
      })
      .finally(function () { save.classList.remove('loading'); });
  }

  if (editPanel) {
    editPanel.addEventListener('change', refreshEdit);
    document.addEventListener('click', function (e) {
      var edit = e.target.closest('[data-cart-edit]');
      if (edit) { e.preventDefault(); openEdit(edit.closest('.cart-line')); return; }
      if (e.target.closest('[data-cart-edit-close]')) { e.preventDefault(); closeEdit(); return; }
      if (e.target.closest('[data-cart-edit-save]')) { e.preventDefault(); saveEdit(); return; }
      // Closing or reopening the drawer always lands back on the cart list.
      if (e.target.closest('[data-cart-drawer] [data-close], [data-cart-open]')) closeEdit();
    });
    document.addEventListener('plakton:cart:added', closeEdit);
  }

  /* ------------------------------------------------------ price slider */
  // Two range inputs share one track. Moving either updates the fields and the
  // hidden inputs the facet form submits. Those hidden inputs are disabled at
  // the ends of the range, so an untouched slider never adds a price filter.
  // Listeners run in the capture phase so values are settled before the
  // facet form's own change handler reads them. Delegated, because filtering
  // replaces the whole sidebar.
  function prParts(el) {
    var wrap = el.closest('[data-price-range]');
    if (!wrap) return null;
    return {
      wrap: wrap,
      max: parseFloat(wrap.getAttribute('data-max')) || 0,
      step: parseFloat(wrap.getAttribute('data-step')) || 1,
      rMin: qs('[data-pr-range="min"]', wrap), rMax: qs('[data-pr-range="max"]', wrap),
      nMin: qs('[data-pr-number="min"]', wrap), nMax: qs('[data-pr-number="max"]', wrap),
      sMin: qs('[data-pr-submit="min"]', wrap), sMax: qs('[data-pr-submit="max"]', wrap),
      fill: qs('[data-pr-fill]', wrap)
    };
  }

  function prApply(p, lo, hi, from) {
    lo = Math.max(0, Math.min(lo, p.max));
    hi = Math.max(0, Math.min(hi, p.max));
    // The thumb being dragged stops at the other one rather than crossing it.
    if (lo > hi) { if (from === 'min') lo = hi; else hi = lo; }
    p.rMin.value = lo; p.rMax.value = hi;
    if (from !== 'nmin') p.nMin.value = lo;
    if (from !== 'nmax') p.nMax.value = hi;
    p.sMin.value = lo; p.sMax.value = hi;
    p.sMin.disabled = lo <= 0;
    p.sMax.disabled = hi >= p.max;
    var a = p.max ? (lo / p.max) * 100 : 0;
    var b = p.max ? (hi / p.max) * 100 : 100;
    p.fill.style.left = a + '%';
    p.fill.style.width = (b - a) + '%';
    // Keep the lower thumb grabbable when both sit at the top end.
    p.rMin.style.zIndex = lo >= p.max - p.step ? 3 : 2;
    p.rMax.style.zIndex = 2;
  }

  function prSync(el, from) {
    var p = prParts(el);
    if (!p) return false;
    if (from === 'min' || from === 'max') {
      prApply(p, parseFloat(p.rMin.value), parseFloat(p.rMax.value), from);
    } else {
      var lo = p.nMin.value === '' ? 0 : parseFloat(p.nMin.value);
      var hi = p.nMax.value === '' ? p.max : parseFloat(p.nMax.value);
      prApply(p, isFinite(lo) ? lo : 0, isFinite(hi) ? hi : p.max, from);
    }
    return true;
  }

  document.addEventListener('input', function (e) {
    var r = e.target.closest('[data-pr-range]');
    if (r) { prSync(r, r.getAttribute('data-pr-range')); return; }
    var n = e.target.closest('[data-pr-number]');
    // Typing only moves the thumbs; the filter applies on change (blur/enter).
    if (n) prSync(n, 'n' + n.getAttribute('data-pr-number'));
  }, true);

  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-pr-range]');
    if (r) { prSync(r, r.getAttribute('data-pr-range')); return; }
    var n = e.target.closest('[data-pr-number]');
    if (n) {
      prSync(n, 'n' + n.getAttribute('data-pr-number'));
      var p = prParts(n);
      // Snap the typed fields to what was actually applied.
      p.nMin.value = p.rMin.value; p.nMax.value = p.rMax.value;
    }
  }, true);

  // Phones: the filter panel folds away behind one button. The panel element
  // itself survives filter re-renders (only its contents are swapped), so the
  // open state holds while shoppers tick through options.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-facets-toggle]');
    if (!t) return;
    var panel = document.getElementById(t.getAttribute('aria-controls'));
    if (!panel) return;
    var open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', String(open));
  });

  function initPriceRanges() {
    qsa('[data-price-range]').forEach(function (wrap) {
      var p = prParts(wrap);
      prApply(p, parseFloat(p.rMin.value), parseFloat(p.rMax.value), 'init');
    });
  }
  // The facet sidebar is re-rendered after every filter change.
  if (window.MutationObserver) {
    var facetRoot = qs('[data-facet-inner]');
    if (facetRoot) new MutationObserver(initPriceRanges).observe(facetRoot, { childList: true });
  }

  /* ------------------------------------------------------ product tabs */
  // Panels are <details> elements, so without JavaScript (or on phones in the
  // default layout) they are plain accordions. Where tabs apply, a tab list is
  // built from them and only the selected panel shows.
  function Tabs(root) {
    var list = qs('[data-ptabs-list]', root);
    var panels = qsa('[data-ptab]', root);
    if (!list || panels.length < 2) return;
    var mode = root.classList.contains('ptabs--tabs-all') ? 'all'
      : root.classList.contains('ptabs--accordion') ? 'none' : 'wide';
    if (mode === 'none') return;
    var mq = window.matchMedia('(min-width: 750px)');
    var uid = 'pt' + Math.random().toString(36).slice(2, 7);

    list.innerHTML = panels.map(function (p, i) {
      return '<button type="button" role="tab" class="ptabs__tab" id="' + uid + '-t' + i + '" aria-controls="' + p.id + '" aria-selected="false" tabindex="-1">' +
        escapeHtml(p.getAttribute('data-ptab-label')) + '</button>';
    }).join('');
    var tabs = qsa('[role="tab"]', list);

    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
        if (on) panels[j].open = true;
      });
      if (focus) tabs[i].focus();
    }
    function apply() {
      var tabbed = mode === 'all' || mq.matches;
      root.classList.toggle('is-tabbed', tabbed);
      list.hidden = !tabbed;
      panels.forEach(function (p, i) {
        p.setAttribute('role', tabbed ? 'tabpanel' : '');
        if (tabbed) p.setAttribute('aria-labelledby', uid + '-t' + i); else p.removeAttribute('aria-labelledby');
        if (!tabbed) { p.hidden = false; }
      });
      if (tabbed) {
        var current = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
        select(current === -1 ? 0 : current);
      }
    }
    list.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (t) select(tabs.indexOf(t));
    });
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i === -1) return;
      var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
      if (n === null) return;
      e.preventDefault();
      select((n + tabs.length) % tabs.length, true);
    });
    // Summaries still toggle in tab mode if clicked by script; keep the
    // selected panel open.
    panels.forEach(function (p) {
      p.addEventListener('toggle', function () {
        if (root.classList.contains('is-tabbed') && !p.hidden && !p.open) p.open = true;
      });
    });
    if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
    apply();

    // "Size guide" links elsewhere can jump to the size tab.
    root.__selectById = function (id) {
      var i = panels.findIndex(function (p) { return p.id === id; });
      if (i === -1) return false;
      if (root.classList.contains('is-tabbed')) select(i); else panels[i].open = true;
      return true;
    };
  }
  qsa('[data-ptabs]').forEach(Tabs);

  /* -------------------------------------------------------- size finder */
  // Picks the smallest size in the chart whose foot length covers the
  // shopper's, among the sizes this product is made in. Styles that run small
  // (Theme settings, Size guide) move up one size.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-size-finder]');
    if (!form) return;
    e.preventDefault();
    var guide = form.closest('[data-size-guide]');
    var out = qs('[data-size-finder-result]', form);
    var mm = parseFloat((qs('input', form).value || '').replace(',', '.'));
    qsa('tr.is-match', guide).forEach(function (r) { r.classList.remove('is-match'); });
    if (!isFinite(mm)) { out.textContent = 'Enter your foot length in millimetres, for example 245.'; return; }
    if (mm < 50) mm = mm * 10; // entered in centimetres
    var rows = qsa('tbody tr', guide).filter(function (r) { return !r.hasAttribute('data-other'); });
    if (!rows.length) rows = qsa('tbody tr', guide);
    var idx = rows.findIndex(function (r) { return parseFloat(r.getAttribute('data-mm')) >= mm; });
    var note = '';
    if (idx === -1) {
      out.textContent = 'Your foot is longer than the largest size in this style. Contact us and we will help you find a fit.';
      return;
    }
    if (guide.hasAttribute('data-size-up')) {
      if (idx + 1 < rows.length) { idx += 1; note = ' This style runs small, so that is one size up.'; }
      else { note = ' This style runs small and this is its largest size, so it may feel snug.'; }
    }
    if (idx === 0 && parseFloat(rows[0].getAttribute('data-mm')) - mm > 10) {
      note += ' Your foot is shorter than this style\'s smallest size, so it may feel roomy.';
    }
    var row = rows[idx];
    row.classList.add('is-match');
    out.innerHTML = 'We recommend <strong>EU ' + escapeHtml(row.getAttribute('data-eu')) + '</strong> (UK ' +
      escapeHtml(row.children[1].textContent) + ').' + escapeHtml(note);
  });

  /* --------------------------------------------------- related products */
  // Swap the fallback grid for Shopify's recommendations when it has some.
  qsa('[data-related]').forEach(function (root) {
    var url = root.getAttribute('data-url');
    var grid = qs('[data-related-grid]', root);
    if (!url || !grid) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var fresh = parse(html).querySelector('[data-related-products]');
        if (fresh && fresh.children.length) {
          grid.innerHTML = '';
          grid.appendChild(fresh);
          sync();
        }
      })
      .catch(function () {});
  });

  /* --------------------------------------------------------------- boot */
  sync();
  initPriceRanges();
  renderWishlistPage();
  renderComparePage();
})();
